function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4138 0C6.9145 0 0 6.91542 0 15.4157C0 21.4895 2.54287 27.6333 7.35373 33.1831C10.9469 37.3283 14.5079 39.6768 14.6579 39.7749C14.8875 39.925 15.1507 40 15.414 40C15.6771 40 15.9404 39.925 16.1701 39.7749C16.3199 39.6768 19.8814 37.3283 23.4747 33.1833C28.2859 27.6333 30.8289 21.4895 30.8289 15.4157C30.8288 6.91542 23.9135 0 15.4138 0ZM15.4138 36.9215C12.5789 34.8091 2.76359 26.6789 2.76359 15.4157C2.76359 8.43926 8.43834 2.76359 15.4138 2.76359C22.3899 2.76359 28.0652 8.43926 28.0652 15.4157C28.0652 26.6789 18.2489 34.8091 15.4138 36.9215Z",
  fill: "#2D2D2D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4147 9.29492C12.0413 9.29492 9.29688 12.0395 9.29688 15.4133C9.29688 18.7862 12.0413 21.5303 15.4147 21.5303C18.7881 21.5303 21.5324 18.7862 21.5324 15.4133C21.5324 12.0397 18.788 9.29492 15.4147 9.29492ZM15.4147 18.7667C13.5651 18.7667 12.0605 17.2624 12.0605 15.4133C12.0605 13.5634 13.5651 12.0585 15.4147 12.0585C17.2641 12.0585 18.7688 13.5634 18.7688 15.4133C18.7688 17.2624 17.2641 18.7667 15.4147 18.7667Z",
  fill: "#B01421"
});

function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 40,
    viewBox: "0 0 31 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.bfab3ec3.svg";
export { ForwardRef as ReactComponent };